import { useMemo } from "react";
import { createMemoryRouter, RouterProvider } from "react-router-dom";

import routes from "./app/routes";
import { PackageContext } from "./quote/context/PackageContext";

interface Props {
  packageId: number;
}

const App = ({ packageId }: Props) => {
  const packageContext = {
    packageId,
  };
  const router = useMemo(() => createMemoryRouter(routes), []);

  return (
    <PackageContext.Provider value={packageContext}>
      <RouterProvider router={router} />
    </PackageContext.Provider>
  );
};

export default App;
